



export const SET_LEAVE_DAYS="SET_LEAVE_DAYS"
export const FETCH_LEAVE_DAYS="FETCH_LEAVE_DAYS"
export const FETCH_LEAVE_DAYS_SUCCESS="FETCH_LEAVE_DAYS_SUCCESS"
export const FETCH_LEAVE_DAYS_FAILURE="FETCH_LEAVE_DAYS_FAILURE"

